import { RxToggle } from "@jauntin/reactables";
import { combine } from "@reactables/core";
import { from } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { RxRequest, FormBuilders } from "@jauntin/reactables";
import CoverageService from "Helpers/CoverageService";
import { control, group } from "@reactables/forms";
import formProviders from "@gbli-events/common/src/Helpers/formProviders";
import { getCaptchaToken } from "@gbli-events/common/src/Helpers/ReCaptchaHelper";
import {
  PolicyVerificationData,
  PolicyVerificationForm,
} from "../Models/policyVerification.model";

export const RxPolicyVerification = ({
  coverageService,
  coverageKey,
}: {
  coverageService: CoverageService;
  coverageKey: string;
}) => {
  const rxForm = FormBuilders.build<PolicyVerificationForm>(
    group({
      controls: {
        policyNumber: control({
          initialValue: "",
          validators: ["required", "length10"],
          normalizers: ["policyNumber"],
        }),
        insuredName: control(["", ["required"]]),
        dailyAttendance: control(["", ["required", "number"]]),
        venueZip: control({
          initialValue: "",
          validators: ["required", "zipCode"],
          normalizers: ["normalizeZip"],
        }),
        insuredZip: control({
          initialValue: "",
          validators: ["required", "zipCode"],
          normalizers: ["normalizeZip"],
        }),
      },
    }),
    {
      name: "rxPolicyVerificationForm",
      providers: formProviders,
    },
  );

  const rxSubmission = RxRequest<
    { formValue: PolicyVerificationForm },
    PolicyVerificationData
  >({
    name: "rxPolicyVerificationSubmission",
    effect: (action$) =>
      action$.pipe(
        mergeMap(async ({ payload: { formValue } }) => {
          const captcha = await getCaptchaToken();
          return { formValue, captcha };
        }),
        map(({ formValue, captcha }) =>
          from(
            coverageService.verifyCoverage({
              ...formValue,
              coverageKey,
              captcha,
            }),
          ).pipe(map(({ data }) => data)),
        ),
      ),
  });

  const rxToggle = RxToggle();

  return combine({
    form: rxForm,
    submission: rxSubmission,
    submitTouched: rxToggle,
  });
};
